import React from 'react';

import SliderArrow from './SliderArrow';

export const defaultSettings = {
    infinite: false,
    slidesToShow: 1,
    slidesToSlide: 3,
    keyBoardControl: true,
    draggable: true,
    transitionDuration: 500,
    swipeable: true,
    arrows: true,
    renderDotsOutside: true,
    additionalTransfrom: 0,
    customRightArrow: <SliderArrow customStyle="wf_multiple_corousal_right" />,
    customLeftArrow: <SliderArrow customStyle="wf_multiple_corousal_left" isLeft={true} />,
    responsive: {
        bigDesktop: {
            breakpoint: {
                max: 3000,
                min: 1920,
            },
            items: 4,
        },
        normalDesktop: {
            breakpoint: {
                max: 1919,
                min: 1160,
            },
            items: 2,
            slidesToSlide: 2,
        },
        tablet: {
            breakpoint: {
                max: 1160,
                min: 960
            },
            items: 2,
            slidesToSlide: 2,
        },
        smallTablet: {
            breakpoint: {
                max: 960,
                min: 464
            },
            items: 2,
            slidesToSlide: 2,
        },
        mobile: {
            breakpoint: {
                max: 464,
                min: 0
            },
            items: 1,
            slidesToSlide: 1,
        },
    }
};


